import React from 'react';
import MainLayout from 'layouts/MainLayout';
import RealtorList from '../RealtorList';
import NoResultsContainer from '../NoResultsContainer';
import SearchRibbonContainer from '../SearchRibbon/SearchRibbonContainer';
import PaginationContainer from '../PaginationContainer';
import { SEOLinks } from '../SEOLinks';

const ResultListView = (props: any) => (
  <MainLayout>
    <SearchRibbonContainer />
    <NoResultsContainer />
    <RealtorList {...props} />
    {props.totalPages > 1 && <PaginationContainer />}
    <SEOLinks />
  </MainLayout>
);

export default ResultListView;
